import { render, staticRenderFns } from "./CtaConferencista.vue?vue&type=template&id=4fa339c7&scoped=true&"
import script from "./CtaConferencista.vue?vue&type=script&lang=js&"
export * from "./CtaConferencista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa339c7",
  null
  
)

export default component.exports